function getNewsletterCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return null;
}

function setNewsletterCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

jQuery(($) => {
  if (getNewsletterCookie('newsletterPopupHide') === 'true') {
    return;
  }

  const newsletterPopup = $('#newsletter-popup');
  if (newsletterPopup) {
    let timeout = newsletterPopup.data('timeout');
    timeout = parseInt(`${timeout}000`, 0);

    setTimeout(() => {
      newsletterPopup.addClass('open');
    }, timeout);

    newsletterPopup.on('click', '.close-popup', () => {
      setNewsletterCookie('newsletterPopupHide', 'true', 14);
      newsletterPopup.removeClass('open');
    });

    newsletterPopup.on('click', '.bg', () => {
      setNewsletterCookie('newsletterPopupHide', 'true', 14);
      newsletterPopup.removeClass('open');
    });
  }
});
